import { render, staticRenderFns } from "./OwalTabBar.vue?vue&type=template&id=99b92766&scoped=true"
import script from "./OwalTabBar.vue?vue&type=script&lang=js"
export * from "./OwalTabBar.vue?vue&type=script&lang=js"
import style0 from "./OwalTabBar.vue?vue&type=style&index=0&id=99b92766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../owal/js/cameras/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b92766",
  null
  
)

export default component.exports